import api from './api'

const inmuebleService = {
  getInmuebles: (filters: any) => api.get('/inmuebles', { params: filters }),
  getInmuebleById: (id: number) => api.get(`/inmuebles/${id}`),
  createInmueble: (data: any) => api.post('/inmuebles', data),
  updateInmueble: (id: number, data: any) => api.put(`/inmuebles/${id}`, data),
  deleteInmueble: (id: number) => api.delete(`/inmuebles/${id}`),
  updateEstadoInmueble: (id: number, estado: string) => api.put(`/inmuebles/${id}/estado`, { status: estado }),
  buscarInmuebles: (term: string) => api.get('/inmuebles/buscar', { params: { term } }),
  getInmueblesDisponibles: () => api.get('/inmuebles/disponibles'),
}

export default inmuebleService


